<script>
    export let url;
    export let mime;
    export let poster;
    export let options = {
                autoplay: false,
                loop: false,
                muted: false,
                playsinline: false,
                controls: true
            };
    export let data;
    //console.log("Video:", data);
</script>

<style>
    video:focus {
      outline:none;
    }
</style>

<video class="{data.blockClasses ? data.blockClasses : ''}" style="{data.blockCustomStyles}" controls="{options.controls}" autoplay="{options.autoplay}" loop="{options.loop}" muted="{options.muted}" playsinline="{options.playsinline}" poster="{poster}">
    <source src="{url}" type="{mime}">
</video>